module.exports = __webpack_public_path__ + "static/img/xf3.f946b96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/xf3.png
// module id = 1bhM
// module chunks = 0